module.exports = __webpack_public_path__ + "static/media/cliente-fert-seeds.f3d7f07e.webp";